import WebComponent from "../../WebComponent";
import ZVVService from "../ZVV/ZVVService";
import BenutzerService from "../Benutzer/BenutzerService";
import {html} from "@isceco/widget-library2/external/lit";
import '@isceco/widget-library2/basic-elements/Dropdown/Dropdown.js'
import '@isceco/widget-library2/basic-elements/Title/Title'
import '@isceco/widget-library2/basic-elements/Button/Button'
import '@isceco/widget-library2/basic-elements/ModalDialog/ModalDialog.js'
import '@isceco/widget-library2/basic-elements/DropdownMultiselect/DropdownMultiselect'
import '@isceco/widget-library2/basic-elements/Form/Form'
import BerechtigungUtil from "../../services/BerechtigungUtil";
import BenutzerDto from "../Benutzer/BenutzerDto";
import AuthorizationFilter from "../Authorization/AuthorizationFilter";
import ZVVDto from "../ZVV/ZVVDto";
import Navigation from "../Navigation/Navigation";
import ZVVEinladungDto from "../ZVV/ZVVEinladungDto";
import GPZVVEinladungColumns from "./GPZVVEinladungColumns";
import BerechtigteListService from "../../services/BerechtigteListService";
import GPZVVEinladungService from "../ZVV/GPZVVEinladungService";
import {List} from "@isceco/widget-library2/basic-elements/List/List";

export default class GPZVV extends WebComponent {
  static get I18N_KEYS() {
    return {
      CANCEL_BUTTON: 'base.button.cancel',
      CONFIRM_BUTTON: 'base.button.confirm'
    }
  }

  static get properties() {
    return {
      selectedBenutzerMail: {type: String},
      selectedZVVEinladung: {type: ZVVEinladungDto}
    }
  }

  constructor() {
    super()
    this.zvvService = new ZVVService('gp', getNavigationId())
    this.benutzerService = new BenutzerService('gp', getNavigationId())
    this.zvvEinladungService = new GPZVVEinladungService('gp', getNavigationId())
    this.showZVVCreateDialog = false
    this.isCreateDialog = null
  }

  get translationFile() {
    return './views/GPDetail/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.all([
      this.zvvService.list(),
      this.zvvEinladungService.getBackendListUrl()
    ]).then(([zvv, einladungUrl]) => {
      this.zvv = new ZVVDto(zvv)
      this.einladungUrl = einladungUrl
    })
      .finally(() => this.render())
  }

  getTemplate() {
    return html`
      <isceco-title size="medium" id="zvv-title" text="${this.i18n.translate('gp.zvv.title')}"></isceco-title>
      <p>${this.i18n.translate('gp.zvv.description')}</p>
      ${this._renderZVV()}
    `
  }

  _renderZVV() {
    if (this.zvv.extId === undefined) {
      return html`
        <p>${this.i18n.translate('gp.zvv.not.included')}</p>
        ${this._renderZVVEinladung()}
      `
    }
    return html`
      <p>${this.i18n.translate('gp.zvv.included')}
        <isceco-link
          text="${this.zvv.name}"
          icon="external alternate"
          @click="${() => navigate({
            to: Navigation.ROUTES.zvvStammdaten.url,
            allow: true,
            id: this.zvv.extId
          })}"
        ></isceco-link>
      </p>
    `
  }

  _renderZVVEinladung() {
    return html`
      <isceco-title size="medium" text="${this.i18n.translate('gp.zvv.einladung.title')}">
        ${this._renderZVVCreateButton()}
      </isceco-title>
      <isceco-list id="zvv-einladung-list"
                   identifier="einladung"
                   url="${this.einladungUrl}"
                   .i18n="${this.i18n}"
                   .dtoMapper="${this._toZVVEinladungDto}"
                   .columns="${GPZVVEinladungColumns.getColumns(this._acceptCallback, this._archiveCallback)}"
                   .listService="${BerechtigteListService}"
      ></isceco-list>
      ${this._renderZVVCreateDialog()}
      ${this._renderBestaetigungsDialog()}
    `
  }

  _renderZVVCreateButton() {
    const roles = new AuthorizationFilter().roles
    if (roles.GP_SUPERUSER) {
      return html`
        <isceco-button icon="plus" size="small"
                       text="${this.i18n.translate('gp.zvv.create')}"
                       @click="${ _ => this._toggleZVVCreateDialog(true) }"
      ></isceco-button>
      `
    }

    return html``
  }

  _renderZVVCreateDialog() {
    if (this.showZVVCreateDialog) {
      return html`
        <isceco-dialog id="zvv-dialog"
                       header="${this.i18n.translate('gp.zvv.create.header')}"
                       confirm-button="${this.i18n.translate(GPZVV.I18N_KEYS.CONFIRM_BUTTON)}"
                       cancel-button="${this.i18n.translate(GPZVV.I18N_KEYS.CANCEL_BUTTON)}"
                       @submit="${event => this._handleSubmitEvent(event)}"
        >
          <isceco-form id="zvv-create-form">
            <div slot="form-elements" class="form-container">
              <isceco-text-input
                name="name"
                label="${this.i18n.translate('gp.zvv.create.name')}"
                required
              ></isceco-text-input>
              <isceco-dropdown
                name="benutzerUuid"
                label="${this.i18n.translate('gp.zvv.create.benutzer')}"
                required
                .items="${this._getBenutzerOptions()}"
                @change="${this._onBenutzerSelectionChange}"
              ></isceco-dropdown>
              <isceco-text-input
                name="email"
                label="${this.i18n.translate('gp.zvv.create.email')}"
                disabled
                .value="${this.selectedBenutzerMail}"
              ></isceco-text-input>
              <isceco-text-input
                name="telefon"
                label="${this.i18n.translate('gp.zvv.create.telefon')}"
                required
                pattern="^(\\+41)(\\s?\\d{2})(\\s?\\d{3})(\\s?\\d{2})(\\s?\\d{2})$"
                pattern-error-text="${this.i18n.translate('gp.zvv.create.telefon.error')}"
              ></isceco-text-input>
            </div>
          </isceco-form>
        </isceco-dialog>
      `
    }
    return html``
  }

  _renderBestaetigungsDialog() {
    if (this.selectedZVVEinladung && this.isCreateDialog != null) {
      return html`
        <isceco-dialog id="zvv-bestaetigungs-dialog"
                       header="${this.i18n.translate(`gp.zvv.bestaetigungs.header.${this.isCreateDialog ? 'accept' : 'decline'}`, {zvvname: this.selectedZVVEinladung.name})}"
                       confirm-button="${this.i18n.translate('gp.zvv.bestaetigungs.confirm')}"
                       cancel-button="${this.i18n.translate('gp.zvv.bestaetigungs.cancel')}"
                       @submit="${event => this._submitBestaetigungsDialog(event)}"
        >
        </isceco-dialog>
      `
    }
    return html``
  }

  _toggleZVVCreateDialog(show) {
    Promise.resolve(
      this.benutzerService.list()
    ).then(benutzerList => {
      this.benutzerList = benutzerList.map(benutzer => new BenutzerDto(benutzer))
    })
      .finally(() => {
        this.showZVVCreateDialog = show
        this.render()
      })

  }

  _handleSubmitEvent = event => {
    if (!event.detail.confirmed) {
      this._toggleZVVCreateDialog(false)
      return
    }
    const form = document.getElementById('zvv-create-form')
    if (form.validate()) {
      this._toggleZVVCreateDialog(false)
      this.zvvService.create(form.getValues())
        .then(() => this._reloadProfile())
    }
  }

  _reloadProfile = () => {
    new BerechtigungUtil().reloadProfile()
      .then(() => this.reload())
  }

  _getBenutzerOptions = () => {
    if (!this.benutzerList) {
      return []
    }
    return this.benutzerList.map(benutzer => ({value: benutzer.uuid, name: benutzer.name}))
  }

  _onBenutzerSelectionChange = event => {
    if (this.benutzerList) {
      const selectedBenutzer = this.benutzerList.find(benutzer => benutzer.uuid === event.detail.value)
      this.selectedBenutzerMail = selectedBenutzer.email
    }
    this.render()
  }

  _acceptCallback = row => {
    this.isCreateDialog = true
    this.selectedZVVEinladung = row
    this.render()
  }

  _archiveCallback = row => {
    this.isCreateDialog = false
    this.selectedZVVEinladung = row
    this.render()
  }

  _submitBestaetigungsDialog = event =>  {
    if (this.isCreateDialog == null || !event.detail.confirmed) {
      this.isCreateDialog = null
      this.selectedZVVEinladung = null
      this.render()
      return
    }
    if (this.isCreateDialog) {
      this.zvvEinladungService.update({id: this.selectedZVVEinladung.id, status: ZVVEinladungDto.ACCEPTED})
        .then(() => this._reloadProfile())
    } else {
      this.zvvEinladungService.update({id: this.selectedZVVEinladung.id, status: ZVVEinladungDto.ARCHIVED})
        .then(() => {
          send(List.EVENT_KEYS.RELOAD_TRIGGERED, {identifier: 'einladung'})
          this.isCreateDialog = null
          this.selectedZVVEinladung = null
          this.render()
        })
    }
  }

  _toZVVEinladungDto = row => new ZVVEinladungDto(row)
}
customElements.define('eko-frontend-gp-detail-zvv', GPZVV)
